import { Component, OnInit, Output, Input } from '@angular/core';
import { CommonService } from '@app/shared/services/common.service';
import { ModalController } from '@ionic/angular';
import { EventEmitter } from '@angular/core';
import { SigninService } from '@app/authentication/services/signin.service';
import { NgForm } from '@angular/forms';
@Component({
    selector: 'app-verify-otp',
    templateUrl: './verify-otp.page.html',
    styleUrls: ['./verify-otp.page.scss'],
    standalone: false
})
export class VerifyOTPPage implements OnInit {
  @Output() public otpVerified = new EventEmitter<boolean>();
  public passwordType = 'password';
  public otpICON = "shield-outline"
  public otp: number | null = null;
  public userInputTooLong: boolean = false;
  public isOTPVerified: boolean = false;
  public checkVerified = false;
  public userContactNumber: any;
  public receiveContactNumber: any;
  @Input() public formData: any;
  constructor(private modalController: ModalController,
    private commonService: CommonService,
    private signInService: SigninService) { }
  public ngOnInit() {
    if (this.formData) {
      this.receiveContactNumber = this.formData;
      this.userContactNumber = this.receiveContactNumber.internationalNumber?.replace(/ /g, '') || '';
    }
  }
  public async dismissModal() {
    await this.modalController.dismiss();
  }
  public showPassword() {
    if (this.passwordType == 'password') {
      this.passwordType = 'text';
    } else {
      this.passwordType = 'password';
    }
  }
  public async verifyOTP(form:NgForm) {
    this.signInService.verifyCode(this.otp).then((res:boolean) => {
      if (res) {
        this.isOTPVerified = true;
        this.otpVerified.emit(this.isOTPVerified);
        this.otpICON = 'shield-checkmark-outline';
        this.commonService.showToastCtrl('OTP Verified Successfully!');
        setTimeout(() => {
          this.modalController.dismiss({ otpVerified: this.isOTPVerified });
        }, 1000); // Delay Added to display animation and Icon change
      } else {
        this.commonService.showToastCtrl('Incorrect OTP Please Try again');
      }
    })
  }
  public resendOTP() {
    this.signInService.sendContactNumberForOTP(this.userContactNumber)
    this.otp=null;
    this.commonService.showToastCtrl('New OTP sent! Please check for the code');
  }
  public onInput(event: any) {
    const inputValue = event.target.value;
    if (inputValue && inputValue.toString().length > 4) {
      this.userInputTooLong = true;
    } else {
      this.userInputTooLong = false;
    }
  }
}
